export default __webpack_public_path__ + "static/5-de189e060b02c4a17ad15530cb01bf2e.jpeg";